module.exports = __webpack_public_path__ + "img/product_6.2127144.jpg";